<div class="rx-card scan-options lab-context">
	<div>
		<div class="rx-card-title">
			<div class="scan-options-title"> {{ 'ScanOptions.AdditionalScansTitle' | translate }} </div>
		</div>
		<div class="scan-options-section rx-app-flex-container-row">
			<tlk-checkbox class="scan-options-checkbox"
				[isDisabled]="true"
				[checked]="rx?.PrePrepScan"
				name="preTreatmentScan">
				{{ 'GeneralRxData.PreTreatmentScan' | translate }}
			</tlk-checkbox>
			<tlk-checkbox class="scan-options-checkbox"
				*ngIf="rx?.EmergenceProfile || (isRxForModelingContext$ | async)"
				[isDisabled]="true"
				[checked]="rx?.EmergenceProfile"
				name="emergenceProfile">
				{{ 'ScanOptions.EmergenceProfile' | translate }}
			</tlk-checkbox>
		</div>
	</div>
	<div class="additional-bites" *ngIf="(isRestoMultiBiteSelected$ | async)">
		<div class="rx-card-title">
			<div class="scan-options-title resto-multi-bite-title"> {{ 'ScanOptions.MultiBite' | translate }} </div>
		</div>
		<div class="additional-bites-row rx-app-flex-container-row rx-app-flex-container-row--wrap">
			<div class="additional-bite"  *ngFor="let bite of additionalBites" [id]= "bite.textKey.toLowerCase()">
				<tlk-checkbox class="additional-bite-checkbox read-only"
					[isDisabled]="true"
					[checked]="isBiteSelected(bite.id) | async">
					{{ 'RestoMultiBite.' + bite.textKey | translate }}
				</tlk-checkbox>
			</div>
		</div>
	</div>
</div>